import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class RouteListener extends Component {
  componentDidMount() {
    this.update();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.update();
    }
  }

  update = () => {
    const { history, match, location } = this.props;
    this.props.updateRouter({ history, match, location });
  };

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

const mapState = () => ({});

const mapDispatch = (store) => ({
  updateRouter: (info) => store.router.updateRouter(info),
});

export default withRouter(connect(mapState, mapDispatch)(RouteListener));
